import React, { useEffect, useCallback, useState} from 'react';
import Arrow from "components/effects/rack/Arrow.js";
import {getPath} from "components/effects/rack/getPath.js"
import {
    setSelectedPianoRollSteps,
    setSelectedPadEdge} from 'actions/index.js';
import {connect} from 'react-redux';

let renderTrackers = {};

const Edge = ({
    scale,
    isSelected,
    outputPrefix, 
    fx,
    pad,
    edge,
    fromId,
    containerRef,
    fromPosition,
    toPosition,
    isSourceCollapsed,
    isDestCollapsed,
    setSelectedPadEdge,
    setSelectedSteps,
    hidden,
    edgesPadding,
    sequencerEngine,
    edgesRef
}) => { 
    outputPrefix = outputPrefix || "effect-output-";

    let [points, setPoints] = useState([]);
    useEffect(() => {
        if (typeof edge.effect === "number") {
            return;
        }
        let toId = edge.effect.id;
        toId = toId === -1 ? pad.effectRack.id : toId;
        let _fromId = edge.outputNumber !== undefined ?
            outputPrefix + edge.outputNumber + '-' + fromId :
            outputPrefix + fromId;
        let fromEl = document.getElementById(_fromId);
        if (edge.effect === pad.effectRack.outputNode) {
            toId = "effect-input-" + pad.effectRack.id + '-speakers';
        } else {
            toId = "effect-input-" + toId;
        }
        let toEl = document.getElementById(toId);
        if (!fromEl || !toEl) {
            return;
        }
        fromEl = fromEl.getBoundingClientRect();
        toEl = toEl.getBoundingClientRect();
        let edgesEl = edgesRef.current.getBoundingClientRect();
        let top = edgesEl.top;
        let left = edgesEl.left;

        let pts = [
            fromEl.left - left,
            fromEl.top - top,
            toEl.left  - left,
            toEl.top - top
        ];
        pts = pts.map(x => x / (window._scale || 1));
        setPoints(pts);
    }, [scale, edgesPadding, fromPosition, toPosition, setPoints, isDestCollapsed, isSourceCollapsed, sequencerEngine]);

    if (points.length === 0) {
        return [];
    }

    let [x1,y1,x2,y2] = points;
    let className = "pad-effect-edge ";
    if (isSelected) {
        className += " selected";
    }

    if (hidden) {
        return '';
    }
    return (
        <Arrow
          onMouseDown={(e) => {
              e.stopPropagation();
              setSelectedPadEdge(edge);
              setSelectedSteps([]);
          }}
          className={className} points={getPath(x1+3,y1,x2+3,y2)}/>
    );
}

const mapStateToProps = (state, props) => {
    let fromId  = props.fx && props.fx.id;
    let toId = props.edge.effect.id;
    toId = toId === -1 ? props.pad.effectRack.id : toId;
    
    let fromPosition= state.windows.windowPositions[
        props.fromWindow || props.fromId || fromId];

    if (props.padZObject) {
        fromPosition = state.windows.windowPositions[props.padZObject.id];
    }
    return {
        fromPosition,
        isSourceCollapsed: state.effects.effectCollapsed[props.fx && props.fx.id],
        isDestCollapsed: state.effects.effectCollapsed[toId],
        isSelected: props.edge === state.pads.selectedEdge,
        toPosition: state.windows.windowPositions[toId],
        hidden: state.spatial.hiddenObjects[props.pad.id],
        edgesPadding: state.spatial.edgesPadding
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedPadEdge: x=>dispatch(setSelectedPadEdge(x)),
      setSelectedSteps: x=>dispatch(setSelectedPianoRollSteps(x))     
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Edge);
